



























































import { Component, Inject } from "vue-property-decorator";
import Context from "@/mixins/context";
import {
  IClientsProvider,
  IClientsProviderMethods
} from "@/models/providers/client";

@Component({
  components: {
    "client-well-link": () =>
      import("@/components/app/admin/clients/clientWellLink.vue")
  }
})
export default class ClientsGrid extends Context {
  // Inject

  @Inject({ from: "clientsProvider" })
  public clientsProvider!: () => IClientsProvider;

  @Inject({ from: "clientsProviderMethods" })
  public $clientsMethods!: IClientsProviderMethods;

  public get $clientsData() {
    return this.clientsProvider();
  }
}
